import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { WhatsAppModal } from '../WhatsAppModal';
import FloatingCards from '../FloatingCards';

const HeroSection = () => {
  return (
    <section className="relative pt-32 pb-40 md:pt-40 md:pb-40 lg:pt-48 lg:pb-40 2xl:pt-56 2xl:pb-40 bg-white dot-pattern overflow-hidden">
      {/* IDA Hero Image - Subtle Background */}
      <div
        className="absolute inset-0 bg-center bg-no-repeat bg-contain opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: 'url(/images/ida-7.svg)',
          backgroundSize: '50%',
          backgroundPosition: 'center 45%'
        }}
      />

      {/* Floating Cards */}
      <FloatingCards />

      {/* Hero Content */}
      <div className="max-w-5xl mx-auto px-4 text-center relative z-10 pt-32">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
          Compliance <span className="text-teal-700">ohne Kopfschmerzen.</span>
        </h1>

        <p className="text-lg md:text-xl text-gray-700 mb-16 max-w-3xl mx-auto">
          Echte Unterstützung bei gesetzlichen und organisatorischen Anforderungen, von HACCP Listen bis zum Spielerschutz.
        </p>

        <div className="flex flex-col items-center gap-6">
          {/* Main CTA Button - Larger and Centered */}
          <Link to="/demo-anfrage">
            <Button size="lg" className="bg-teal-700 hover:bg-teal-800 px-12 py-6 text-xl rounded-xl shadow-lg">
              Live-Demo anfragen
            </Button>
          </Link>

          {/* Secondary Links - Subtle */}
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 items-center text-center">
            <button
              onClick={() => window.open('/pdfs/responsible-gaming-report.pdf', '_blank')}
              className="text-teal-700 hover:text-teal-800 font-medium underline transition-colors"
            >
              Beispiel-Report (PDF) ansehen
            </button>
            <WhatsAppModal>
              <button className="flex items-center gap-2 text-green-600 hover:text-green-700 font-medium underline transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
                WhatsApp Business Chat
              </button>
            </WhatsAppModal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
